var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    className: "pass",
    width: 24,
    height: 27,
    viewBox: "0 -2 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.8984,
    r: 9,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.89844C6.5 1.89844 2 6.39844 2 11.8984C2 17.3984 6.5 21.8984 12 21.8984C17.5 21.8984 22 17.3984 22 11.8984C22 6.39844 17.5 1.89844 12 1.89844ZM10 16.8984L5 11.8984L6.41 10.4884L10 14.0684L17.59 6.47844L19 7.89844L10 16.8984Z",
    fill: "#000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pass-icon.d4af6776fcd957f66cf5e81ff1bf71ae.svg";